import { render, staticRenderFns } from "./SpecialAttachments.vue?vue&type=template&id=2f2b064d&scoped=true"
import script from "./SpecialAttachments.vue?vue&type=script&lang=js"
export * from "./SpecialAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b064d",
  null
  
)

export default component.exports